import { useEffect } from 'react';
import useProductStore from '../stores/useProductStore';


export function useProductFeedEffects({
  project,
  feedPage,
  feedPageIndex,
  productIndex,
  reloadingProducts,
  setProduct,
  setProductFields,
}) {
  useEffect(() => {
    const currentIndex = productIndex % feedPage?.page_size;
    if (feedPage?.products?.length && currentIndex < feedPage.products.length) {
      if (!reloadingProducts) setProduct(feedPage.products[currentIndex]);
    }
  }, [feedPage, productIndex, reloadingProducts, setProduct]);

  useEffect(() => {
    if (project?.feed?.feed_fields) setProductFields(JSON.parse(project.feed.feed_fields));
  }, [project, setProductFields]);

  useEffect(() => {
    useProductStore.getState().loadFeed();
  }, [project, feedPageIndex]);

}
